import React from "react";
import * as Icons from 'react-bootstrap-icons';
import Translator from "Languages/Utility/Translator";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";

export default function CalcedFinalPrice() {
    const { t } = useTranslation();
    const { factorPrice } = useSelector((state) => ({
        factorPrice: state.factor.factorPrice,
    }));
    return (
        <div className="d-flex flex-row flex-nowrap">
            <Icons.CashStack size={20} className="mx-2"/>
            <Translator id='FinalPrice' />
            <span className="mx-1">:</span>
            <span className={`m-0 ${factorPrice ? 'text-success' : 'text-danger'}`}>
                {
                    factorPrice ? (
                        <>
                            <strong style={{'fontSize':'13px'}}>
                                {factorPrice.toLocaleString("ar-SA")}
                            </strong>
                            <span className="mr-1">{t('moneyUnit')}</span>
                        </>
                    ) : factorPrice === 0 ? t('priceNotEntered') : t('notCalculated')
                }
            </span>
        </div>
    );
};